import axios from 'axios';
import { Store } from 'vuex';
import VueRouter from 'vue-router';

const url = 'https://junkit.vonigo.com/api/v1/security/login/'

export default class AccountService {
  constructor(private store: Store<any>, private cookie: any, private router: VueRouter) {
    this.init();
  }

  public init(): void {

  }

  public getToken(appVersion: string, company: string, password: string, userName: string): Promise<string> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${url}?appVersion=${appVersion}&company=${company}&password=${password}&userName=${userName}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
